import { Component, computed, input } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import {
    ColumnConfig,
    ColumnValue,
} from '@app/shared/services/view-configs/column-creator';
import { TableRowData } from '@app/shared/models/table-data-types';

interface TourDeliveryNoteBundleGroupLike {
    bundleGroupKey?: string;
    deliveryNoteKey?: string;
}

/**
 * Marks a tour whose delivery notes are (partly) processed via bundle groups
 * (Mappengruppen). The tooltip states how many of the tour's delivery notes
 * belong to a group.
 */
@Component({
    selector: 'app-tour-bundle-groups-display',
    template: `
        <div class="tw-flex tw-justify-center">
            @if (groupedCount() > 0) {
                <mat-icon
                    fontSet="material-symbols-outlined"
                    class="tw-text-primary"
                    [matTooltip]="
                        'INCOMING-GOODS.BUNDLE-GROUPS.TOUR-DELIVERY-NOTES-HINT'
                            | translate
                                : {
                                      count: groupedCount(),
                                      total: totalCount(),
                                  }
                    ">
                    inventory_2
                </mat-icon>
            }
        </div>
    `,
    standalone: true,
    imports: [TranslateModule, MatIconModule, MatTooltipModule],
})
export class TourBundleGroupsDisplayComponent {
    value = input<ColumnValue>();
    row = input<TableRowData>();
    column = input<ColumnConfig>();
    index = input<number>(0);
    parentRow = input<TableRowData>();

    groupedCount = computed(() => {
        const groups = this.bundleGroups();
        const deliveryNoteKeys = new Set(
            groups
                .map(group => group?.deliveryNoteKey)
                .filter((key): key is string => !!key)
        );
        return deliveryNoteKeys.size;
    });

    totalCount = computed(() => {
        const row = this.row() as { deliveryNoteKeys?: unknown } | undefined;
        const keys = row?.deliveryNoteKeys;
        return Array.isArray(keys) ? keys.length : 0;
    });

    private bundleGroups(): TourDeliveryNoteBundleGroupLike[] {
        const row = this.row() as
            | { deliveryNoteBundleGroups?: unknown }
            | undefined;
        const groups = row?.deliveryNoteBundleGroups;
        return Array.isArray(groups)
            ? (groups as TourDeliveryNoteBundleGroupLike[])
            : [];
    }
}
